const fileIcons = {
  checklist: 'repair',
  chart: 'chart',
  video: 'youtube',
  presentation: 'presentation',
  patient: 'id',
  infection: 'form',
  unit: 'doctor',
  catheter: 'dropper',
  bacteria: 'petri-dish',
  guide: 'guide',
  flowChart: 'flow-chart',
  definition: 'dictionary',
  general: 'notebook',
  score: 'scoreboard',
  folder: 'folder',
  lungs: 'lungs',
  blood: 'blood',
  hospital: 'hospital',
  exposition: 'schedule',
  csv: 'csv'
}

const bacteria = {
  title: 'Pour chaque bactériémie associée aux soins',
  icon: 'bacteria',
  texts: [
    `Fiche unique avec données patients et données
relatives à l'épisode bactériémique : date de l'épisode, germes et les
résistances associées, porte d'entrée.`,
    `Documentation précise des bactériémies associées aux dispositifs
intra-vasculaires (délai entre pose du cathéter et épisode infectieux).`,
    `En option, documentation des bactériémies à porte d'entrée urinaire
chez les patients ayant un antécédent récent de sondage vésical.`
  ]
}

const reaUnit = {
  title: `Pour les services de réanimation, néonatalogie, hémodialyse, ou
tout autre service volontaire`,
  icon: 'oxygen-1'
}

export default {
  title: {
    main: 'SPIADI',
    subtitle: `Surveillance et Prévention des Infections Associées aux
Dispositifs Invasifs`
  },

  texts: {
    causeAnalysis: [
      {
        title: 'Analyse des causes des bactériémies liées à un cathéter',
        subtitle: `Outil disponible toute l'année`,
        icon: 'event',
        text: `Les inscriptions sont ouvertes, rendez vous dans votre espace
SPIADI.`
      },
      {
        title: 'Saisie des fiches sur le site',
        subtitle: `
<strong>
  Impérativement avant le
  <span class="text-danger">31&nbsp;juillet&nbsp;2026</span> afin de participer
  à l'analyse nationale.
</strong>`,
        icon: 'medical-history-1'
      },
      {
        title: 'Analyses et Rapports nationaux',
        subtitle: `
<strong>
  L'analyse nationale sera présentée lors de la journée
  nationale le <span class="text-danger">13&nbsp;octobre&nbsp;2026</span>.
</strong>`,
        icon: 'analytics-1'
      }
    ],
    badiCause: [
      {
        title: `Inscription en ligne à partir de votre espace SPIADI`,
        texts: [
          `En utilisant l'encart «Analyse des causes» sur l'accueil de votre établissement.`
        ],

        icon: 'registration'
      },
      {
        title: 'Pour tous les services',
        texts: [
          `L’outil est adapté à l’analyse des causes des bactériémies liées à un cathéter
(tous types de cathéters intravasculaires), acquises dans tous les secteurs
(adulte, pédiatrique et néonatal), tous types de services et tous types
d’établissements.`
        ],
        icon: 'hospital',
        separator: {
          hr: true
        }
      },
      {
        title: `En cas de détection d’une bactériémie liée à un cathéter acquise dans l’établissement`,
        icon: fileIcons.bacteria,
        texts: [
          `La participation au programme de surveillance SPIADI 2026 via <span class='label
label-bactADI'>Bact ADI</span>, <span class='label label-expADI'>ExpADI</span>,
<span class='label label-reaInfADI'>Réa Inf ADI</span>, <span class='label
label-neoInfADI'>Néo Inf ADI</span> ou <span class='label label-diaInfADI'>Dia
Inf ADI</span> permet de faciliter la détection des bactériémies liées à un cathéter
pendant votre période de surveillance mais <strong>n’est pas impérative</strong> pour
participer à <span class='label label-badiCause'>BADICAUSE</span>.`
        ],
        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Programmation d'une réunion avec tous les professionnels concernés`,
        texts: [
          `Idéalement dans les 3 mois qui suivent l’évènement.`
        ],
        icon: fileIcons.exposition,
        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Analyse des causes à l’aide de la fiche <span class='label label-badiCause'>BADICAUSE</span>`,
        texts: [
          `Le responsable local utilise la fiche <span class='label label-badiCause'>BADICAUSE</span> pour préparer et mener la
réunion.`
        ],
        icon: fileIcons.checklist,
        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Diffusion locale des enseignements de la réunion`,
        texts: [
          `Les informations sur les enseignements et les recommandations tirés de cet
évènement sont diffusées et partagées localement en vue de renforcer la solidité
du processus de soins concerné.`
        ],
        icon: fileIcons.unit,
        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 300%;',
          hr: true
        }
      },
      {
        title: `Contribution à l'analyse nationale`,
        texts: [
          `La fiche <span class='label label-badiCause'>BADICAUSE</span> est saisie sur le site SPIADI par le responsable local du
programme afin d'alimenter l'analyse nationale.`
        ],
        icon: fileIcons.presentation
      }
    ],

    observation: [
      {
        title: 'Observation des pratiques',
        subtitle: `
            <strong>
            Entre le 1er&nbsp;janvier et le
            <span class="text-danger">15&nbsp;juillet&nbsp;2026</span>.
            </strong>`,
        icon: 'event',
        text: `Les inscriptions sont ouvertes, rendez vous dans votre espace
          SPIADI.`
      },
      {
        title: 'Saisie des fiches sur le site',
        subtitle: `
            <strong>
            Impérativement avant le
            <span class="text-danger">31&nbsp;juillet&nbsp;2026</span> (OBSERVA4 & SPY4).
            </strong>`,
        icon: 'medical-history-1'
      },
      {
        title: 'Analyses et Rapports nationaux',
        subtitle: `
            <strong>
            Les analyses et rapports nationaux seront présentés lors de la journée
          nationale le <span class="text-danger">13&nbsp;octobre&nbsp;2026</span>.
            </strong>`,

        icon: 'analytics-1'
      }
    ],
    common: [
      {
        title: '3 mois de surveillance',
        subtitle: `
            <strong>
            Compris entre le 1er&nbsp;janvier et le
            <span class="text-danger">15&nbsp;juillet&nbsp;2026</span>.
            </strong>`,
        icon: 'event',
        text: `Les inscriptions sont ouvertes, rendez vous dans votre espace
          SPIADI.`
      },
      {
        title: 'Saisie/Import des fiches sur le site',
        subtitle: `
            <strong>
            Pour les rapports nationaux : saisie avant le
            <span class="text-danger">31&nbsp;juillet&nbsp;2026</span>
            et envoi des fichiers d'import avant le
  <span class="text-danger">15&nbsp;juillet&nbsp;2026</span>.
</strong>
`,
        icon: 'medical-history-1',
        text: `
Possibilité de saisie/import toute l'année, import sous format .csv.
            `
      },
      {
        title: 'Données établissements',
        subtitle: `
            <strong>
            À saisir ou importer sur le site impérativement avant le
            <span class="text-danger">31&nbsp;juillet&nbsp;2026</span>.
            </strong>`,
        icon: 'hospital',
        text: `Données nécessaires au calcul des indicateurs pour les services surveillés:  
          nombre de jours d'hospitalisation, nombre d'admissions, etc.`
      },
      {
        title: 'Analyses et Rapports nationaux',
        subtitle: `
            <strong>
            Les analyses et rapports nationaux seront présentés lors de la journée
          nationale le <span class="text-danger">13&nbsp;octobre&nbsp;2026</span>.
            </strong>`,
        icon: 'analytics-1'
      },
      {
        title: 'Exploration des données',
        subtitle: `
            <strong>
            Statistiques et graphiques calculés en temps réel à partir des fiches.
            </strong>`,
        icon: 'analysis',
        text: `Ce module est en construction et évoluera tout au long de l'année en
fonction de vos demandes.`
      }
    ],

    observa4: [
      {
        title: 'Pour tous les services',
        icon: 'stethoscope',
        texts: [
          `L'enquête concerne les pratiques des professionnels de santé en
          charge de la pose et/ou de la manipulation des cathéters. Le nombre de fiches
          (minimum 5, recommandé 30) et les thèmes d'observations sont laissés au choix du
responsable de l'enquête.`
        ]
      },
      {
        title: `Observation directe des pratiques suivie d'un entretien
dirigé de l'audité`,
        icon: fileIcons.checklist,
        texts: [
          `8 fiches à disposition : 5 pour la pose, 2 pour les manipulations et 1 pour
          la réfection de pansement d'un cathéter central.`
        ]
      },
      {
        title: `État des lieux des pratiques`,
        texts: [
          `Avec pour objectif de définir les priorités de formation à mettre
en oeuvre.`
        ],
        icon: fileIcons.presentation
      }
    ],

    reaExplaur: [
      {
        title: `Pour les services de réanimation, de soins intensifs ou soins continus`,
        icon: 'oxygen-1',
        texts: [
          `Pour les services participant à une surveillance : <span class="label label-bactADI">Bact ADI</span>
<span class="label label-expADI">Exp ADI</span> <span class="label label-reaInfADI">Réa Inf ADI</span> <span class="label label-neoInfADI">Néo Inf ADI</span>.`,
          `Plusieurs services d'un même établissement peuvent participer.`
        ]
      },
      {
        title: `État des lieux des pratiques de prévention des bactériémies liées
          aux cathéters (B-div)`,
        icon: fileIcons.checklist,
        texts: [
          `Une fiche décrivant les mesures de prévention des B-div mises en place dans chaque service participant.`,
          `Une fiche par patient ayant acquis une B-div à <i>S. aureus</i> décrivant
          les mesures mises en oeuvre pour ce patient.`
        ]
      },
      {
        title: `Étude microbiologique des souches de <i>S. aureus</i>
            responsables de bactériémies associées aux soins`,
        icon: 'swabs',
        texts: [
          `Virulence, sensibilité aux antibiotiques et antiseptiques, capacité
          à produire du biofilm.`
        ]
      }
    ],

    spy4: [
      {
        title: 'Pour tous les services',
        icon: 'hospital',
        texts: [
          `Plusieurs services d'un même établissement peuvent participer.`
        ]
      },
      {
        title: `Étude un jour donné de tous les patients du service`,
        icon: fileIcons.patient,
        texts: [
          `Collecte des caractéristiques patients :
âge, sexe, immunodépression, cancer évolutif et port de dispositifs intra-vasculaire.`,
          `<u>Pour les porteurs de MIDline</u>, collecte des données d'utilisation du dispositif :
          indication et traçabilité de la pose, traitements potentiellement irritants perfusés, surveillance
          quotidienne et justification du maintien.`,
          `<u>Pour les porteurs de CVPs courts</u>, la collecte des données d'utilisation
du dispositif est possible mais <u>optionnelle</u>.`
        ]
      },
      {
        title: `Prévalence du port des dispositifs intra-vasculaires et état des lieux de
l'utilisation des MIDlines et des CVPs courts`,
        texts: [
          `Avec pour objectif de définir les priorités de formation à mettre
          en oeuvre.`
        ],
        icon: fileIcons.presentation
      }
    ],

    bacteriemie: [
      {
        title: 'Pour tous les services',
        icon: 'stethoscope',
        texts: [
          `Les services de Réanimation sont encouragés à participer à Exp ADI.`
        ]
      },
      bacteria
    ],

    exp: [
      reaUnit,
      {
        title: `Mesure de l'exposition aux dispositifs invasifs à l'échelle
          du service`,
        icon: 'dropper',
        texts: [ 'Cathéterisme vasculaire, ventilation, etc.' ]
      },
      bacteria,
      {
        title: `Pour chaque pneumopathie associée aux soins <br>(optionnel)`,
        icon: 'lungs',
        texts: [
          `Fiche unique avec données patients et données relatives à l'épisode
infectieux : date de l'épisode, germes et résistances associées.`
        ]
      },
      {
        title: `Pour chaque sepsis néonatal associé aux soins <br>(optionnel)`,
        icon: 'newborn',
        texts: [
          `Fiche unique avec données patients et données relatives à l'épisode
infectieux : date de l'épisode et porte d'entrée suspectée.`
        ]
      }
    ],

    reaB: [
      {
        title: 'Pour les services de réanimation',
        icon: 'oxygen-1',
        text: `
Les soins intensifs, les services de néonatalogie et les services d'hémodialyse
          peuvent également opter pour cette surveillance.
            `
      },
      {
        title: 'Pour chaque bactériémie associée aux soins',
        icon: 'bacteria',
        text: `
          Fiche unique avec données patients et données
          relatives à l'épisode bactériémique : date de l'épisode, germes et les
          résistances associées, porte d'entrée.
`
      },
      {
        title: "Mesure de l'exposition CVC",
        icon: 'dropper',
        text: `Inclusion de tout patient hospitalisé plus de 48h.`
      },
      {
        title: 'Pour les services de néonatalogie',
        icon: 'baby',
        text: `Inclusion de tout nouveau-né porteur de CVC ou CVO.`
      }
    ],

    reaI: [
      {
        title: `Pour les services de réanimation, néonatalogie et hémodialyse`,
        icon: 'oxygen-1',
        type: 'reaInfADI'
      },
      {
        title: `Mesure de l'exposition aux dispositifs invasifs par le suivi
des patients hospitalisés plus de 48h.`,
        icon: 'dropper',
        type: 'reaInfADI',
        texts: [ 'Cathéterisme vasculaire, ventilation, etc.' ]
      },
      {
        title: `Pour chaque infection associée aux soins (Bactériémies, ILC,
Pneumopathies, …) et pour les colonisations de CVC (optionnel)`,
        icon: 'petri-dish',
        type: 'reaInfADI',
        texts: [
          `Fiche unique avec données patients et données relatives à l'épisode
infectieux : date de l'épisode, germes et les résistances associées, porte
d'entrée.`
        ]
      },
      {
        title: 'Pour les services de néonatalogie',
        icon: 'baby',
        type: 'neoInfADI',
        texts: [ `Inclusion de tout nouveau-né porteur de CVC ou CVO.` ]
      },
      {
        title: `Pour les services d'hémodialyse`,
        icon: 'blood',
        type: 'diaInfADI',
        texts: [
          `Inclusion de tous les patients dialysés pendant la période de
surveillance, détection des infections associées aux cathéters de dialyse et
aux fistules.`
        ]
      }
    ]
  },

  files: {
    spiadi: [
      {
        title: 'Fiche Établissement',
        icon: fileIcons.hospital,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/spiadi/SPIADI2026 - Fiche établissement.pdf',
        description: 'SPIADI2026 - Fiche établissement.pdf'
      },
      {
        title: `Fiche Données d'activité - Dénominateurs`,
        icon: fileIcons.hospital,
        text: `Version 1 - 03/12/2025`,
        link: `documents/spiadi/SPIADI2026 - Fiche données d'activité - dénominateurs.pdf`,
        description: `SPIADI2026 - Fiche données d'activité - dénominateurs.pdf`
      },
      {
        title: `Procédure d'envoi des fichiers d'import`,
        icon: fileIcons.flowChart,
        text: `Version 1 - 08/08/2023`,
        link: `documents/spiadi/SPIADI2026 - Procédure envoi fichier import.pdf`,
        description: `SPIADI2026 - Procédure envoi fichier import.pdf`
      }
    ],
    annexes: [
      {
        title: `Définition et diagnostic des pneumopathies`,
        icon: fileIcons.definition,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Definition et diagnostic des pneumopathies.pdf',
        description: 'SPIADI2026 - Annexe Definition et diagnostic des pneumopathies.pdf',
        multiRef: false
      },
      {
        title: `Réa - Définition et diagnostic des COL, ILC, BLC et SEPSIS`,
        icon: fileIcons.definition,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Réa Definition et diagnostic COL ILC BLC et SEPSIS.pdf',
        description: 'SPIADI2026 - Annexe Réa Definition et diagnostic COL ILC BLC et SEPSIS.pdf',
        multiRef: false
      },
      {
        title: `Cathéters`,
        icon: fileIcons.catheter,
        text: `En cours d'adaptation au programme 2026`,
        plink: 'documents/annexes/SPIADI2026 - Annexe Catheters.pdf',
        description: 'SPIADI2026 - Annexe Catheters.pdf',
        multiRef: false
      },
      {
        title: `Micro-organismes`,
        icon: fileIcons.bacteria,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Micro-organismes.pdf',
        description: 'SPIADI2026 - Annexe Micro-organismes.pdf',
        multiRef: false
      },
      {
        title: `Détection des bactériémies associées aux soins`,
        icon: fileIcons.flowChart,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Détection BAS.pdf',
        description: 'SPIADI2026 - Annexe Détection BAS.pdf',
        multiRef: false
      },
      {
        title: `Détection des bactériémies liées aux cathéters`,
        icon: fileIcons.flowChart,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Détection BLC.pdf',
        description: 'SPIADI2026 - Annexe Détection BLC.pdf',
        multiRef: false
      },
      {
        title: `Codage des disciplines et spécialités`,
        icon: fileIcons.unit,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Codage disciplines et spécialités.pdf',
        description: 'SPIADI2026 - Annexe Codage disciplines et spécialités.pdf',
        multiRef: true
      },
      {
        title: `Score de sévérité`,
        icon: fileIcons.score,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Score de sévérité.pdf',
        description: 'SPIADI2026 - Annexe Score de sévérité.pdf',
        multiRef: false
      }
    ],
    bactADI: [
      {
        title: `Guide Technique Bact ADI+`,
        icon: fileIcons.guide,
        text: `Version 2 - 14/01/2026`,
        link: 'documents/bactADI/SPIADI2026 - BACT ADI+ - Guide Technique (Version 2).pdf',
        description: 'SPIADI2026 - BACT ADI+ - Guide Technique (Version 2).pdf'
      },
      {
        title: `Fiche Bact ADI+`,
        icon: fileIcons.infection,
        text: `Version 1 - 24/11/2025`,
        link: 'documents/bactADI/SPIADI2026 - BACT ADI+ - Fiche.pdf',
        description: 'SPIADI2026 - BACT ADI+ - Fiche.pdf'
      },
      {
        title: `Modèle de fichier pour import de fiches Bact ADI+`,
        icon: fileIcons.csv,
        text: `Version 1 - 18/12/2025`,
        link: 'documents/bactADI/SPIADI2026 - BACT ADI+.xlsx',
        description: 'SPIADI2026 - BACT ADI+.xlsx'
      }
    ],
    expADI: [
      {
        title: `Guide Technique Exp ADI`,
        icon: fileIcons.guide,
        text: `Version 2 - 14/01/2026`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Guide Technique (Version 2).pdf',
        description: 'SPIADI2026 - EXP ADI - Guide Technique (Version 2).pdf'
      },
      {
        title: `Fiche Bactériémie`,
        icon: fileIcons.infection,
        text: `Version 1 - 25/11/2025`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Fiche Bactériémie.pdf',
        description: 'SPIADI2026 - EXP ADI - Fiche Bactériémie.pdf'
      },
      {
        title: `Fiche Pneumopathie`,
        icon: fileIcons.infection,
        text: `Version 1 - 25/11/2025`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Fiche Pneumopathie.pdf',
        description: 'SPIADI2026 - EXP ADI - Fiche Pneumopathie.pdf'
      },
      {
        title: `Fiche Sepsis`,
        icon: fileIcons.infection,
        text: `Version 1 - 25/11/2025`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Fiche Sepsis.pdf',
        description: 'SPIADI2026 - EXP ADI - Fiche Sepsis.pdf'
      },
      {
        title: `Tableau Exposition Général`,
        icon: fileIcons.exposition,
        text: `Version 2 - 14/01/2026`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Général (Version 2).pdf',
        description: 'SPIADI2026 - EXP ADI - Tableau Exp-Général (Version 2).pdf'
      },
      {
        title: `Tableau Exposition Oncologie`,
        icon: fileIcons.exposition,
        text: `Version 2 - 14/01/2026`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Onco (Version 2).pdf',
        description: 'SPIADI2026 - EXP ADI - Tableau Exp-Onco (Version 2).pdf'
      },
      {
        title: `Tableau Exposition Réanimation`,
        icon: fileIcons.exposition,
        text: `Version 2 - 14/01/2026`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Réa AD PED (Version 2).pdf',
        description: 'SPIADI2026 - EXP ADI - Tableau Exp-Réa AD PED (Version 2).pdf'
      },
      {
        title: `Tableau Exposition Néonatalogie`,
        icon: fileIcons.exposition,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Néo.pdf',
        description: 'SPIADI2026 - EXP ADI - Tableau Exp-Néo.pdf'
      },
      {
        title: `Tableau Exposition Dialyse`,
        icon: fileIcons.exposition,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI - Tableau Exp-Dia.pdf',
        description: 'SPIADI2026 - EXP ADI - Tableau Exp-Dia.pdf'
      },
      {
        title: `Modèle de fichier pour import de fiches Exp ADI`,
        icon: fileIcons.csv,
        text: `Version 1 - 18/12/2025`,
        link: 'documents/expADI/SPIADI2026 - EXP ADI.xlsx',
        description: 'SPIADI2026 - EXP ADI.xlsx'
      }
    ],
    reaInfADI: [
      {
        title: `Guide Technique Réa Inf ADI - AD/PED`,
        icon: fileIcons.guide,
        type: 'reaInfADI',
        text: `Version 1 - 25/11/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - RÉA INF ADI - AD PED - Guide Technique (Version 2).pdf',
        description: 'SPIADI2026 - RÉA INF ADI - AD PED - Guide Technique (Version 2).pdf'
      },
      {
        title: `Fiche Réa Inf ADI - AD/PED`,
        icon: fileIcons.folder,
        type: 'reaInfADI',
        text: `Version 1 - 25/11/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - RÉA INF ADI - AD PED - Fiche.pdf',
        description: 'SPIADI2026 - RÉA INF ADI - AD PED - Fiche.pdf'
      },
      {
        title: `Modèle de fichier pour import de fiches Réa Inf ADI - AD PED`,
        icon: fileIcons.csv,
        type: 'reaInfADI',
        text: `Version 2 - 21/04/2026`,
        link: 'documents/reaInfADI/SPIADI2026 - RÉA INF ADI - AD PED.xlsx',
        description: 'SPIADI2026 - RÉA INF ADI - AD PED.xlsx'
      },
      {
        title: `Guide Technique Néo Inf ADI`,
        icon: fileIcons.guide,
        type: 'neoInfADI',
        text: `Version 1 - 03/12/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - NÉO INF ADI - Guide Technique.pdf',
        description: 'SPIADI2026 - NÉO INF ADI - Guide Technique.pdf'
      },
      {
        title: `Fiche Néo Inf ADI`,
        icon: fileIcons.folder,
        type: 'neoInfADI',
        text: `Version 1 - 25/11/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - NÉO INF ADI - Fiche.pdf',
        description: 'SPIADI2026 - NÉO INF ADI - Fiche.pdf'
      },
      {
        title: `Modèle de fichier pour import de fiches Néo Inf ADI`,
        icon: fileIcons.csv,
        type: 'neoInfADI',
        text: `Version 1 - 18/12/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - NÉO INF ADI.xlsx',
        description: 'SPIADI2026 - NÉO INF ADI.xlsx'
      },
      {
        title: `Guide Technique Dia Inf ADI`,
        icon: fileIcons.guide,
        type: 'diaInfADI',
        text: `Version 2 - 14/01/2026`,
        link: 'documents/reaInfADI/SPIADI2026 - DIA INF ADI - Guide Technique (Version 2).pdf',
        description: 'SPIADI2026 - DIA INF ADI - Guide Technique (Version 2).pdf'
      },
      {
        title: `Fiche Dia Inf ADI`,
        icon: fileIcons.folder,
        type: 'diaInfADI',
        text: `Version 1 - 25/11/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - DIA INF ADI - Fiche.pdf',
        description: 'SPIADI2026 - DIA INF ADI - Fiche.pdf'
      },
      {
        title: `Modèle de fichier pour import de fiches Dia Inf ADI`,
        icon: fileIcons.csv,
        type: 'diaInfADI',
        text: `Version 1 - 18/12/2025`,
        link: 'documents/reaInfADI/SPIADI2026 - DIA INF ADI.xlsx',
        description: 'SPIADI2026 - DIA INF ADI.xlsx'
      }
    ],
    observa4: [
      {
        title: `Guide Technique OBSERVA4`,
        icon: fileIcons.guide,
        text: `Version 2 - 03/03/2026`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Guide Technique.pdf',
        description: 'SPIADI2026 - OBSERVA4 - Guide Technique.pdf'
      },
      {
        title: `Fiche P1<br>Préparation du site de pose d'un cathéter central ou
d'un MIDline avec prolongateur intégré ou d'un cathéter artériel`,
        icon: fileIcons.checklist,
        text: `Version 1 - 24/11/2025`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P1 (Version 1).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche P1 (Version 1).pdf'
      },
      {
        title: `Fiche P2<br>Préparation du site de pose d'un cathéter
veineux périphérique court ou d'un MIDline sans prolongateur intégré`,
        icon: fileIcons.checklist,
        text: `Version 1 - 24/11/2025`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P2 (Version 1).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche P2 (Version 1).pdf'
      },
      {
        title: `Fiche P3<br>Préparation du site de pose d'une aiguille
sur CCI`,
        icon: fileIcons.checklist,
        text: `Version 1 - 24/11/2025`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P3 (Version 1).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche P3 (Version 1).pdf'
      },
      {
        title: `Fiche P4<br>Préparation du site de pose d'un cathéter
sous-cutané`,
        icon: fileIcons.checklist,
        text: `Version 1 - 27/11/2025`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P4 (Version 1).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche P4 (Version 1).pdf'
      },
      {
        title: `Fiche P5<br>Préparation du site de pose sur fistule
artério-veineuse native, prothétique ou goretex`,
        icon: fileIcons.checklist,
        text: `Version 1 - 05/01/2026`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche P5 (Version 1).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche P5 (Version 1).pdf'
      },
      {
        title: `Fiche B1<br>Manipulation distale d'une ligne associée
à un cathéter central ou assimilé et toutes manipulations sur cvp et
midline sans prolongateur intégré`,
        icon: fileIcons.checklist,
        text: `Version 2 - 20/02/2026`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche B1 (Version 2).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche B1 (Version 2).pdf'
      },
      {
        title: `Fiche B2<br>Manipulation proximale d'une ligne associée à
un cathéter central ou assimilé`,
        icon: fileIcons.checklist,
        text: `Version 2 - 20/02/2026`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche B2 (Version 2).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche B2 (Version 2).pdf'
      },
      {
        title: `Fiche R1<br>Réfection d'un pansement de cathéter central
ou assimilé`,
        icon: fileIcons.checklist,
        text: `Version 1 - 06/01/2026`,
        link: 'documents/observa4/SPIADI2026 - OBSERVA4 - Fiche R1 (Version 1).pdf',
        description: 'SPIADI2026 - OBSERVA4 - Fiche R1 (Version 1).pdf'
      }
    ],
    reaExplaur: [
      {
        title: `Guide Technique RÉA expl AUR`,
        icon: fileIcons.guide,
        text: `Version 1 - 08/12/2025`,
        link: 'documents/reaExplaur/SPIADI2026 - RÉA EXPL AUR - Guide Technique.pdf',
        description: 'SPIADI2026 - RÉA EXPLAUR - Guide Technique.pdf'
      },
      {
        title: `Fiche Service RÉA expl AUR`,
        icon: 'oxygen-1',
        text: `Version 1 - 08/12/2025`,
        link: 'documents/reaExplaur/SPIADI2026 - RÉA EXPL AUR - Fiche Service.pdf',
        description: 'SPIADI2026 - RÉA EXPL AUR - Fiche Service.pdf'
      },
      {
        title: `Fiche Patient RÉA expl AUR`,
        icon: fileIcons.infection,
        text: `Version 1 - 08/12/2025`,
        link: 'documents/reaExplaur/SPIADI2026 - RÉA EXPL AUR - Fiche Patient.pdf',
        description: 'SPIADI2026 - RÉA EXPL AUR - Fiche Patient.pdf'
      }
    ],

    spy4: [
      {
        title: `Guide Technique SPY4`,
        icon: fileIcons.guide,
        text: `Version 1 - 15/01/2026`,
        link: 'documents/spy4/SPIADI2026 - SPY4 - Guide Technique.pdf',
        description: 'SPIADI2026 - SPY4 - Guide Technique.pdf'
      },
      {
        title: `Fiche SPY4`,
        icon: fileIcons.checklist,
        text: `Version 1 - 15/01/2026`,
        link: 'documents/spy4/SPIADI2026 - SPY4 - Fiche (Version 1).pdf',
        description: 'SPIADI2026 - SPY4 - Fiche (Version 1).pdf'
      }
    ],

    badiCause: [
      {
        title: `Guide Technique BADICAUSE`,
        icon: fileIcons.guide,
        text: `Version 1 - 10/03/2026`,
        link: 'documents/badiCause/SPIADI2026 - BADICAUSE - Guide Technique.pdf',
        description: 'SPIADI2026 - BADICAUSE - Guide Technique.pdf'
      },
      {
        title: `Fiche BADICAUSE 1<br><small class='txt-dark-badiCause'>CVC, CCI, CVO, PICC, CDIA ou midline avec prolongateur intégré</small>`,
        icon: fileIcons.checklist,
        text: `Version 1 - 10/03/2026`,
        link: 'documents/badiCause/SPIADI2026 - BADICAUSE - Fiche 1 - CVC, CCI, CVO, PICC, CDIA ou midline avec prolongateur intégré (Version 1).pdf',
        description: 'SPIADI2026 - BADICAUSE - Fiche 1 - CVC, CCI, CVO, PICC, CDIA ou midline avec prolongateur intégré (Version 1).pdf'
      },
      {
        title: `Fiche BADICAUSE 2<br><small class='txt-dark-badiCause'>CVP court ou midline sans prolongateur intégré</small>`,
        icon: fileIcons.checklist,
        text: `Version 1 - 10/03/2026`,
        link: 'documents/badiCause/SPIADI2026 - BADICAUSE - Fiche 2 - CVP court ou midline sans prolongateur intégré (Version 1).pdf',
        description: 'SPIADI2026 - BADICAUSE - Fiche 2 - CVP court ou midline sans prolongateur intégré (Version 1).pdf'
      }
    ],

    causeAnnexes: [
      {
        title: `Définition et diagnostic des pneumopathies`,
        icon: fileIcons.definition,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Definition et diagnostic des pneumopathies.pdf',
        description: 'SPIADI2026 - Annexe Definition et diagnostic des pneumopathies.pdf'
      },
      {
        title: `Cathéters`,
        icon: fileIcons.catheter,
        text: `En cours d'adaptation au programme 2026`,
        plink: 'documents/annexes/SPIADI2026 - Annexe Catheters.pdf',
        description: 'SPIADI2026 - Annexe Catheters.pdf',
        multiRef: false
      },
      {
        title: `Micro-organismes`,
        icon: fileIcons.bacteria,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Micro-organismes.pdf',
        description: 'SPIADI2026 - Annexe Micro-organismes.pdf',
        multiRef: false
      },
      {
        title: `Détection des bactériémies associées aux soins`,
        icon: fileIcons.flowChart,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Détection BAS.pdf',
        description: 'SPIADI2026 - Annexe Détection BAS.pdf',
        multiRef: false
      },
      {
        title: `Détection des bactériémies liées aux cathéters`,
        icon: fileIcons.flowChart,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Détection BLC.pdf',
        description: 'SPIADI2026 - Annexe Détection BLC.pdf',
        multiRef: false
      },
      {
        title: `Codage des disciplines et spécialités`,
        icon: fileIcons.unit,
        text: `Version 1 - 03/12/2025`,
        link: 'documents/annexes/SPIADI2026 - Annexe Codage disciplines et spécialités.pdf',
        description: 'SPIADI2026 - Annexe Codage disciplines et spécialités.pdf',
        multiRef: true
      }
    ],

    zips: {
      observa4: {
        pfile: 'documents/observa4/SPIADI2021 - OBSERVA4.zip',
        description: 'SPIADI2021 - OBSERVA4.zip'
      },

      spiadi: {
        pfile: 'documents/spiadi/SPIADI2021.zip',
        description: 'SPIADI2021.zip'
      },

      annexes: {
        pfile: 'documents/annexes/SPIADI2021 - Annexes.zip',
        description: 'SPIADI2021 - Annexes.zip'
      },

      bactADI: {
        pfile: 'documents/bactADI/SPIADI2021 - BACT-ADI+.zip',
        description: 'SPIADI2021 - BACT ADI+.zip'
      },

      expADI: {
        pfile: 'documents/expADI/SPIADI2021 - EXP-ADI.zip',
        description: 'SPIADI2021 - EXP ADI.zip'
      },

      reaInfADI: {
        pfile: 'documents/reaInfADI/SPIADI2021 - REA INF-ADI.zip',
        description: 'SPIADI2021 - REA INF ADI.zip'
      }
    }
  }
}
